import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';

declare var Intercom: any;
declare let window: any;

@Component({
  selector: 'app-developers-home',
  templateUrl: './developers.component.html',
  styleUrls: ['./developers.component.scss']
})
export class DevelopersComponent implements OnInit {
  constructor(private router: Router) {
  }

  ngOnInit(): void {
  }

  toLogin() {
    this.router.navigate(['/auth/login']);
  }

  toContact() {
    console.log('toContact');
    window.sa_event('contact_us', {page: 'developers'});
    Intercom('showNewMessage');
  }

  toFreeTrial() {
    this.router.navigate(['/auth/login'], {queryParams: {signUp: 'true'}});
  }

  toDemo() {
    console.log('toDemo');
    window.sa_event('book_demo', {page: 'developers'});
    window.open(environment.bookDemoUrl, '_blank');
  }
}
